import React from 'react';
import { useTranslation } from 'next-i18next';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { CvDetailInterface } from '../interface/CvDetailInterface';

export const ProfileRequirementAnswers = ({ cvDetail }: CvDetailInterface) => {
  const { t } = useTranslation('common');

  const requirementAnswers = cvDetail?.application?.requirementAnswers;

  // Don't render if no requirement answers
  if (!requirementAnswers || requirementAnswers.length === 0) {
    return null;
  }

  return (
    <>
      <h3 className="mb-3 text-lg font-bold">{t('cv.detail.requirement_answers')}</h3>

      {requirementAnswers.map((item) => (
        <div key={item.question || Math.random()} className="mb-4 border-b pb-4">
          <div className="flex items-start gap-2">
            {/* Icon based on answer value */}
            {item.answer === true ? (
              <CheckCircleIcon className="mt-0.5 size-5 shrink-0 text-green-600" />
            ) : (
              <XCircleIcon className="mt-0.5 size-5 shrink-0 text-red-600" />
            )}

            {/* Question text */}
            <div className="flex-1">
              <div className="text-ink-dark text-sm font-medium">{item.question}</div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
